import React, { forwardRef } from 'react';
import { Typography as MuiTypography, TypographyProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Mode } from '../../constants/enums';

interface IProps extends TypographyProps {
  isContrastColor?: boolean;
  isDarkTextColor?: boolean;
  darkModeColor?: string;
}

const CustomTypography = forwardRef<HTMLElement, IProps>(({
  isContrastColor = false,
  isDarkTextColor = false,
  darkModeColor,
  sx,
  ...rest
}, ref) => {
  const theme = useTheme();

  const getColor = () => {
    if (isContrastColor) {
      return theme.palette.secondary.contrastText;
    }
    if ((isDarkTextColor || darkModeColor) && theme.palette.mode === Mode.Dark) {
      return darkModeColor ?? '#ffffff';
    }
    return undefined;
  };

  const color = getColor();

  return (
    <MuiTypography
      ref={ref}
      {...rest}
      sx={[
        ...(color ? [{ color }] : []),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  );
});

CustomTypography.displayName = 'CustomTypography';

export default CustomTypography;
